module.exports = __webpack_public_path__ + "media/src/images/student-tasks/timer-37d0c860ac9765fa4c824e780be424f6.svg";